import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export interface ISectionCardProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Global brand section card — mirrors the `/mui-preview` lab `Section` pattern.
 * Paper wrapper (16px radius + border from `MuiPaper`), h6 title, body2 subtitle.
 * Mobile-first: padding scales down on xs via responsive `sx`.
 */
export const SectionCard = ({ title, subtitle, actions, children }: ISectionCardProps) => (
  <Paper sx={{ p: { xs: 2, sm: 2.5 }, mb: { xs: 2, sm: 2.5 } }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      sx={{ mb: subtitle || actions ? 2 : 0 }}
    >
      <Box>
        <Typography variant="h6" sx={{ mb: subtitle ? 0.5 : 0 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>{actions}</Box>}
    </Stack>
    {children}
  </Paper>
);
